<template>
	<UApp>
		<NuxtLayout>
			<NuxtPage />
		</NuxtLayout>
		<ClientOnly>
			<AnalyticsConsent />
		</ClientOnly>
	</UApp>
</template>

<script setup lang="ts">
useHead({
	link: [{ rel: 'icon', type: 'image/svg+xml', href: '/favicon.svg' }]
});
useSeoMeta({
	ogTitle: '%s'
});
</script>
